@use "variables" as *;

.fieldTitle {
  font-size: $fontSize-s;
  font-weight: bold;
  margin: $spacing-s 0 $spacing-xs 0;
}
